import { render, staticRenderFns } from "./base-input-check.vue?vue&type=template&id=6bbd9353&scoped=true&"
import script from "./base-input-check.vue?vue&type=script&lang=ts&"
export * from "./base-input-check.vue?vue&type=script&lang=ts&"
import style0 from "./base-input-check.vue?vue&type=style&index=0&id=6bbd9353&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bbd9353",
  null
  
)

export default component.exports